import { MyWellbeingReferralsPage } from "@features/wellbeing-referrals/components/MyWellbeingReferralsPage";
import { createFileRoute } from "@tanstack/react-router";

export const Route = createFileRoute("/_layout/referrals/wellbeing/my/$referralId")({
	component: MyWellbeingReferralsPage,
});
